var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 6.49996C13.6246 6.49996 15.0417 5.08288 15.0417 3.33329C15.0417 1.58371 13.6246 0.166626 11.875 0.166626C10.1254 0.166626 8.70834 1.58371 8.70834 3.33329C8.70834 5.08288 10.1254 6.49996 11.875 6.49996ZM4.75001 4.91663V2.54163H3.16667V4.91663H0.791672V6.49996H3.16667V8.87496H4.75001V6.49996H7.12501V4.91663H4.75001ZM11.875 8.08329C9.76126 8.08329 5.54167 9.14412 5.54167 11.25V12.8333H18.2083V11.25C18.2083 9.14412 13.9888 8.08329 11.875 8.08329Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMember);
export default __webpack_public_path__ + "static/media/add-member.51154edc.svg";
export { ForwardRef as ReactComponent };